import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { db } from '../firebase.js';
import { doc, onSnapshot, getDoc } from 'firebase/firestore';

const SurveyContext = createContext();

export const useSurvey = () => {
  const context = useContext(SurveyContext);
  if (!context) {
    throw new Error('useSurvey must be used within a SurveyProvider');
  }
  return context;
};

export const SurveyProvider = ({ children }) => {
  const { currentUser } = useAuth();
  const [pendingSurvey, setPendingSurvey] = useState(false);
  const [surveyId, setSurveyId] = useState(null);
  const [showSurveyPopup, setShowSurveyPopup] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) {
      setLoading(false);
      return;
    }

    // Check if user has a pending survey
    const checkPendingSurvey = async () => {
      try {
        // Check if user is a client (not internal user)
        const userDoc = await getDoc(doc(db, 'clients', currentUser.uid));
        
        if (userDoc.exists()) {
          const userData = userDoc.data();
          
          if (userData.pendingSurvey && userData.surveyId) {
            setPendingSurvey(true);
            setSurveyId(userData.surveyId);
            
            // Show survey popup after a short delay
            setTimeout(() => {
              setShowSurveyPopup(true);
            }, 1000);
          }
        }
      } catch (error) {
        console.error('Error checking pending survey:', error);
      } finally {
        setLoading(false);
      }
    };

    checkPendingSurvey();

    // Listen for changes to user's survey status
    if (currentUser.uid) {
      const unsubscribe = onSnapshot(doc(db, 'clients', currentUser.uid), (doc) => {
        if (doc.exists()) {
          const userData = doc.data();
          
          if (userData.pendingSurvey && userData.surveyId) {
            setPendingSurvey(true);
            setSurveyId(userData.surveyId);
            
                         // Only show popup if it's not already showing
             if (!showSurveyPopup) {
               setTimeout(() => {
                 setShowSurveyPopup(true);
               }, 1000);
             }
          } else {
            setPendingSurvey(false);
            setSurveyId(null);
            setShowSurveyPopup(false);
          }
        }
      });

      return () => unsubscribe();
    }
  }, [currentUser, showSurveyPopup]);

  const closeSurveyPopup = () => {
    setShowSurveyPopup(false);
  };

  const value = {
    pendingSurvey,
    surveyId,
    showSurveyPopup,
    closeSurveyPopup,
    loading
  };

  return (
    <SurveyContext.Provider value={value}>
      {children}
    </SurveyContext.Provider>
  );
};
